import { useNavigate } from 'react-router-dom';

export default function CTASection() {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-darkBlue-500 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full"
          style={{
            backgroundImage: 'radial-gradient(circle at 20% 50%, #7EC8E3 1px, transparent 1px), radial-gradient(circle at 80% 50%, #7EC8E3 1px, transparent 1px)',
            backgroundSize: '30px 30px'
          }}
        ></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center">
          <h2 className="font-display text-3xl lg:text-5xl font-bold text-white mb-4 leading-tight">
            Ready to grow your business or start earning online?
          </h2>
          <p className="text-gray-300 text-lg mb-10 max-w-2xl mx-auto">
            Take the first step towards your digital success. Our team is ready to help you achieve your goals.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate('/services')}
              className="flex items-center justify-center gap-2 bg-clairBlue-300 hover:bg-clairBlue-200 text-darkBlue-500 font-bold text-base px-8 py-4 rounded-xl transition-all hover:scale-105 whitespace-nowrap"
            >
              Start a Project
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => navigate('/ai-money')}
              className="flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/30 text-white font-bold text-base px-8 py-4 rounded-xl backdrop-blur-sm transition-all hover:scale-105 whitespace-nowrap"
            >
              Explore AI Tools
              <i className="ri-external-link-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}